import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Lesson } from './Lesson';
var Lessons = function (_a) {
    var lessons = _a.lessons, assignedLessons = _a.assignedLessons, onAssign = _a.onAssign, onDelete = _a.onDelete;
    return (_jsx(_Fragment, { children: lessons.map(function (_a) {
            var id = _a.id, name = _a.name, description = _a.description;
            return (_jsx(Lesson, { text: name, description: description, checked: assignedLessons.includes(id), id: id, onAssign: onAssign, onDelete: onDelete }, id));
        }) }, void 0));
};
export { Lessons };
